import React, { Fragment, useState, useEffect } from "react";
import { Route } from "react-router";

import Common from "./Components/Shared/Common";
import { SiteNotAvailable } from './Components/Brands/SiteNotAvailable';

import { PaellaKing } from      './Components/Brands/PK/Start';
import { BirdsMouth } from      './Components/Brands/BM/Start';
import { RTech } from           './Components/Brands/RTech/Start';
import Bakery from              './Components/Brands/GBK/Start';
import SpearfishingAcademy from './Components/Brands/ASA/Start';
import KingFishCup from         "./Components/Brands/KFC/Start";

import KingFishCupManage from "./Components/Brands/KFC/App/ManageDivers";
import KingFishCupAllFish from "./Components/Brands/KFC/App/ManageFish";
import { KingFishCupSignUp, KingFishCupSignOn, KingFishCupSignWeightIn, KingFishCupSignOff, KingFishCupAddDiver } from "./Components/Brands/KFC/App/DiverOperations";


import { SSD } from "./Components/Brands/SSD/Start";
import Comps_Home from "./Components/Controls/Branded/Diving/Comps/_Home";
import Comps_ClubLeaderBoard from "./Components/Controls/Branded/Diving/Comps/ClubLeaderBoard";
import Comps_PuckoResults from "./Components/Controls/Branded/Diving/Comps/PuckoResults";
import Comps_ClubRecords from "./Components/Controls/Branded/Diving/Comps/ClubRecords";
import Comps_ClubCompsResults from "./Components/Controls/Branded/Diving/Comps/ClubCompResults";
import Comps_SubmitClubRecord from "./Components/Controls/Branded/Diving/Comps/SubmitClubRecord";
import Comps_NationalResults from "./Components/Controls/Branded/Diving/Comps/NationalResults";

import Members_Home from "./Components/Controls/Branded/Diving/Mem/_Home";

const ApplicationRouting = (props) => {

    const [brandCode, setBrandCode] = useState("");

    useEffect(() => {
        Common.traceInit("Application Routing for Brand " + props.brandCode);
        setBrandCode(props.brandCode);

    }, [props.brandCode]);

    return ( 
        <Fragment>
            {brandCode === "" ? (
                <>
                    <Route exact path='/' component={SiteNotAvailable} />
                </>
            ) : (
                <>
                    {brandCode === "PK" && <Route exact path='/' component={PaellaKing} />}
                    {brandCode === "BM" && <Route exact path='/' component={BirdsMouth} />}
                    {brandCode === "ASA" && <Route exact path='/' component={SpearfishingAcademy} />}
                    {brandCode === "RTech" && <Route exact path='/' component={RTech} />}
                    {brandCode === "KFC" && <Route exact path='/' component={KingFishCup} />}
                    {brandCode === "GBK" && <Route exact path='/' component={Bakery} /> }

                    {brandCode === "KFC" && <Route exact path='/Register' component={KingFishCupSignUp} />}
                    {brandCode === "KFC" && <Route exact path='/SignOn' component={KingFishCupSignOn} />}
                    {brandCode === "KFC" && <Route exact path='/SignOff' component={KingFishCupSignOff} />}

                    {brandCode === "KFC" && <Route exact path='/2025' component={KingFishCup} />}
                    {brandCode === "KFC" && <Route exact path='/ManageDiversAdmin' component={KingFishCupManage} />}
                    {brandCode === "KFC" && <Route exact path='/ManageFishAdmin' component={KingFishCupAllFish} /> }
                    {brandCode === "KFC" && <Route exact path='/AddWeightIn' component={KingFishCupSignWeightIn} />}
                    {brandCode === "KFC" && <Route exact path='/AddDiver' component={KingFishCupAddDiver} />}
                    {brandCode === "KFC" && <Route exact path='/AddWeightIn/:emailAddress' render={(props) => <KingFishCupSignWeightIn {...props} />} />}


                    {brandCode === "SSD" && <Route exact path='/' component={SSD} />}
                    
                    {brandCode === "SSD" && <Route exact path='/Competitions/Home' component={Comps_Home} />}
                    {brandCode === "SSD" && <Route exact path='/Competitions/ClubLeaderBoard' component={Comps_ClubLeaderBoard} />}
                    {brandCode === "SSD" && <Route exact path='/Competitions/ClubRecords' component={Comps_ClubRecords} />}
                    {brandCode === "SSD" && <Route exact path='/Competitions/ClubCompsResults' component={Comps_ClubCompsResults} />}
                    {brandCode === "SSD" && <Route exact path='/Competitions/ThePucko' component={Comps_PuckoResults} />}
                    {brandCode === "SSD" && <Route exact path='/Competitions/SubmitClubRecord' component={Comps_SubmitClubRecord} />}
                    {brandCode === "SSD" && <Route exact path='/Competitions/NationalResults' component={Comps_NationalResults} />}

                    {brandCode === "SSD" && <Route exact path='/Members/Home' component={Members_Home} />}
                    {brandCode === "SSD" && <Route exact path='/Members/Me' component={Members_Home} />}
                    {brandCode === "SSD" && <Route exact path='/Members/Login' component={Members_Home} />}
                    {brandCode === "SSD" && <Route exact path='/Members/Shop' component={Members_Home} />}
                </>
            )}
        </Fragment>
    );
};
export default ApplicationRouting;
